import React, { useState } from 'react';
import AuthLayout from '../AuthLayout';
import SetPasswordForm from './SetPasswordForm';

export default function SetPassword() {
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  return (
    <AuthLayout
      title="Set Password"
      errorMsg={error ? 'Failed to set password.' : ''}
      successMsg={success ? 'Successfully set password.' : ''}
    >
      <SetPasswordForm setError={setError} setSuccess={setSuccess} />
    </AuthLayout>
  );
}
